import { useTranslation } from 'react-i18next'

import Icon from '@/components/Icon'
import Price from '@/components/Price'

import useCheckout from '../../hooks/useCheckout'
import { SummaryBarTotal, SummaryBarWrapper } from './SummaryBar.styles'

interface SummaryBarProps {
  actionBack?: React.ReactNode
  actionSubmit?: React.ReactNode
  hideTotal?: boolean
}

const SummaryBar = ({ actionBack, actionSubmit, hideTotal = false }: SummaryBarProps) => {
  const { cartTotal } = useCheckout()
  const { t } = useTranslation()

  return (
    <SummaryBarWrapper>
      {actionBack}
      {!hideTotal && (
        <SummaryBarTotal>
          <Icon name="cart" />
          <span>{t('toPay')}:</span>
          <Price>{cartTotal}</Price>
        </SummaryBarTotal>
      )}
      {actionSubmit}
    </SummaryBarWrapper>
  )
}

export default SummaryBar
